<InactivityModal />

<!-- App shell: navbar + sidebar fixed; only content scrolls -->
<div class="vh-100 d-flex flex-column bg-gray overflow-hidden">

  <!-- Navbar (same component & behavior) -->
  <Navbar
    @sidebar-toggle="toggleSidebar"
    class="navbar navbar-expand-lg sticky-top bg-white border-bottom w-100 p-0 m-0">
  </Navbar>

  
  <Sidebar variant="mobile" offcanvas_id="dashboardSidebarOffcanvas" />
<!-- Main area below navbar fills remaining height -->
  <div class="container-fluid flex-grow-1 overflow-hidden">
    <div class="row h-100">

      <!-- Sidebar column (same Sidebar component; no scrolling) -->
      <div class="col-auto bg-white h-100 d-none d-lg-block rounded-end mt-2">
        <div class="mt-2">
          <Sidebar ref="sidebar"></Sidebar>
        </div>
      </div>

      <!-- Content column (the ONLY scrollable area) -->
      <div class="col h-100 overflow-auto mt-2">
        <div class="card rounded-5  border-0 mt-5 card-nav-tabs">
        <div class="card-header rounded-5 card-header-primary">
          <div class="nav-tabs-navigation">
                <div class="nav-tabs-wrapper">
            <ul class="nav nav-tabs text-xxs" id="events-tab" role="tablist">
            <li class="nav-item text-sm" role="presentation">
                <button class="nav-link active" id="upcoming_events_tab" data-bs-toggle="pill"
                    data-bs-target="#upcoming_events_info" type="button" role="tab"
                    aria-controls="upcoming_events_info" aria-selected="true">
                    Upcoming Events
                </button>
            </li>
            <li class="nav-item text-sm" role="presentation">
                <button class="nav-link" id="past_events_tab" data-bs-toggle="pill"
                    data-bs-target="#past_events_info" type="button" role="tab"
                    aria-controls="past_events_info" aria-selected="false">
                    Past Events
                </button>
            </li>
            <li class="nav-item text-sm" role="presentation">
                <button class="nav-link" id="free_events_tab" data-bs-toggle="pill"
                    data-bs-target="#free_events_info" type="button" role="tab"
                    aria-controls="free_events_info" aria-selected="false">
                    Free Events
                </button>
            </li>
            <li class="nav-item text-sm" role="presentation">
                <button class="nav-link" id="paid_events_tab" data-bs-toggle="pill"
                    data-bs-target="#paid_events_info" type="button" role="tab"
                    aria-controls="paid_events_info" aria-selected="false">
                    Paid Events
                </button>
            </li>
          </ul>
            </div>
            </div>
          </div>
        <!-- ================= DESKTOP (keeps background card) ================= -->
        <div class="visitor-card shadow border-primary">
          <div class="card-body bg-white">
            <button
          class="btn btn-light border rounded-circle d-inline-flex d-lg-none align-items-center justify-content-center p-0 dashboard-workspace-menu me-2 mb-2"
          type="button"
          data-bs-toggle="offcanvas"
          data-bs-target="#dashboardSidebarOffcanvas"
          aria-controls="dashboardSidebarOffcanvas"
          aria-label="Open workspace menu"
        >
          <i class="bx bx-menu-alt-left fs-5"></i>
        </button>

          <div class="tab-content">
            <!-- DESKTOP TABLE (unchanged) -->
            <div class="tab-pane fade show active" id="upcoming_events_info" role="tabpanel">
              <div class="row g-2 mb-3">
                <div
                  v-for="card in event_dashboard_cards"
                  :key="card.label"
                  class="col-6 col-md-4 col-xl-3"
                >
                  <button
                    type="button"
                    class="dashboard-summary-card btn border rounded bg-white p-3 h-100 w-100 text-start shadow-sm"
                    :class="{ 'border-primary bg-light': is_event_dashboard_card_active(card) }"
                    @click="handle_event_dashboard_card_click(card)"
                  >
                    <div class="d-flex align-items-start justify-content-between gap-3 h-100">
                      <div class="d-flex flex-column justify-content-between h-100 min-w-0">
                        <div class="text-muted text-xxs fw-bold text-uppercase text-truncate">{{ card.label }}</div>
                        <div class="fw-bold text-dark h4 mb-0 mt-2">{{ card.value }}</div>
                      </div>
                      <span class="portal-dashboard-card-icon rounded-circle d-inline-flex align-items-center justify-content-center bg-light border flex-shrink-0">
                        <i class="bi" :class="[`text-${card.tone}`, card.icon]"></i>
                      </span>
                    </div>
                  </button>
                </div>
              </div>

              <div class="row g-2 mb-3">
                <div
                  v-for="card in ticket_dashboard_cards"
                  :key="card.label"
                  class="col-6 col-md-4 col-xl"
                >
                  <div class="border rounded bg-white p-3 h-100 shadow-sm">
                    <div class="d-flex align-items-start justify-content-between gap-3 h-100">
                      <div class="d-flex flex-column justify-content-between h-100 min-w-0">
                        <div class="text-muted text-xxs fw-bold text-uppercase text-truncate">{{ card.label }}</div>
                        <div class="fw-bold text-dark h5 mb-0 mt-2">{{ card.value }}</div>
                      </div>
                      <span class="portal-dashboard-card-icon rounded-circle d-inline-flex align-items-center justify-content-center bg-light border flex-shrink-0">
                        <i class="bi" :class="[`text-${card.tone}`, card.icon]"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div v-if="loading" class="text-center py-5 w-100">
              <div class="spinner-border text-secondary" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
              <p class="mt-2 mb-0 text-muted text-xxs">Loading Event List...</p>
            </div>
            <div v-else="!isLoading">
            <div class="mt-2">
                  <div class="d-flex align-items-center justify-content-end flex-wrap gap-2 mb-3">
                    <button v-if="events.length"class="btn btn-sm btn-primary text-xxs mb-2 rounded" @click="openCreateModal">
                      Create Event
                    </button>
                </div>
              <div v-if="filtered_dashboard_events && filtered_dashboard_events.length" class="table-responsive">
                <table id="table" class="table align-middle table-striped table-borderless mb-0">
                  <thead class="text-uppercase btn-primary text-white">
                    <tr>
                      <th class="text-xxs fw-light text-center">No.</th>
                      <th class="text-xxs fw-light">Event</th>
                      <th class="text-xxs fw-light text-center">Event Type</th>
                      <th class="text-xxs fw-light text-center">Start Date</th>
                      <th class="text-xxs fw-light text-center">End Date</th>
                      <th class="text-xxs fw-light text-center">Organizer</th>
                      <th class="text-xxs fw-light text-center">Location</th>
                      <th class="text-xxs fw-light text-center">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(event, index) in filtered_dashboard_events" :key="event.id" class="border-bottom text-xxs">
                      <td class="text-center">
                        <span>{{ index + 1 }}</span>
                      </td>
                      <td><div class="text-xxs">{{ event.event_name }}</div></td>
                      <td class="text-center">
                        <span>{{ event.is_free ? 'Free Event' : 'Paid Event' }}</span>
                      </td>
                      <td class="text-center">{{ event.start_date }}</td>
                      <td class="text-center">{{ event.end_date }}</td>
                      <td class="text-center">{{ event.organizer }}</td>
                      <td class="text-center event-location-cell">{{ event.location }}</td>
                      <td class="text-center">
                        <div class="d-flex justify-content-center gap-1">
                          <button class="btn btn-light btn-sm rounded text-success border text-xxs" @click.prevent="view_event(event)">View</button>
                          <button class="btn btn-light btn-sm rounded text-success border text-xxs" @click.prevent="edit_event(event)">Edit</button>
                          <button class="btn btn-light btn-sm rounded text-danger border text-xxs" @click.prevent="deleteEvent(event.id)">Delete</button>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <!-- Desktop empty state -->
              <div v-else class="text-center py-5">
                <i class="bi bi-calendar3 display-1 text-muted mb-3" aria-hidden="true"></i>
                <p class="text-muted fs-5 mb-1">No events yet.</p>
                <p class="text-muted text-xxs mb-3">When you create events, they will appear here.</p>
                <button class="btn btn-primary btn-sm text-xxs" @click="openCreateModal">Create your first event</button>
              </div>
            </div>
            </div>
            </div>
            <!-- past events-->
             <div class="tab-pane fade" id="past_events_info" role="tabpanel">

                    <div class="mt-2">
                      <div class="row g-2 mb-3">
                        <div
                          v-for="card in past_event_dashboard_cards"
                          :key="card.label"
                          class="col-6 col-md-4 col-xl-3"
                        >
                          <button
                            type="button"
                            class="dashboard-summary-card btn border rounded bg-white p-3 h-100 w-100 text-start shadow-sm"
                            :class="{ 'border-primary bg-light': is_past_event_dashboard_card_active(card) }"
                            @click="handle_past_event_dashboard_card_click(card)"
                          >
                            <div class="d-flex align-items-start justify-content-between gap-3 h-100">
                              <div class="d-flex flex-column justify-content-between h-100 min-w-0">
                                <div class="text-muted text-xxs fw-bold text-uppercase text-truncate">{{ card.label }}</div>
                                <div class="fw-bold text-dark h4 mb-0 mt-2">{{ card.value }}</div>
                              </div>
                              <span class="portal-dashboard-card-icon rounded-circle d-inline-flex align-items-center justify-content-center bg-light border flex-shrink-0">
                                <i class="bi" :class="[`text-${card.tone}`, card.icon]"></i>
                              </span>
                            </div>
                          </button>
                        </div>
                      </div>

            <div v-if="filtered_past_dashboard_events && filtered_past_dashboard_events.length" class="table-responsive">
                <table class="table align-middle table-striped table-borderless mb-0 data-table">
                  <thead class="text-uppercase btn-primary text-white">
                    <tr>
                      <th class="text-xxs fw-light text-center">No.</th>
                      <th class="text-xxs fw-light">Event</th>
                      <th class="text-xxs fw-light text-center">Event Type</th>
                      <th class="text-xxs fw-light text-center">Recurrence</th>
                      <th class="text-xxs fw-light text-center">Start Date</th>
                      <th class="text-xxs fw-light text-center">End Date</th>
                      <th class="text-xxs fw-light text-center">Organizer</th>
                      <th class="text-xxs fw-light text-center">Location</th>
                      <th class="text-xxs fw-light text-center">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(event, index) in filtered_past_dashboard_events" :key="event.id" class="border-bottom text-xxs">
                      <td class="text-center">{{ index + 1 }}</td>
                      <td><div class="text-xxs">{{ event.event_name }}</div></td>
                      <td class="text-center">
                        <span>{{ event.is_free ? 'Free Event' : 'Paid Event' }}</span>
                      </td>
                      <td class="text-center">{{ event.recurring_pattern?.name || '—' }}</td>
                      <td class="text-center">{{ event.start_date }}</td>
                      <td class="text-center">{{ event.end_date }}</td>
                      <td class="text-center">{{ event.organizer }}</td>
                      <td class="text-center event-location-cell">{{ event.location }}</td>
                      <td class="text-center">
                        <div class="d-flex justify-content-center gap-1">
                          <button class="btn btn-light btn-sm rounded text-success border text-xxs" @click.prevent="view_event(event)">View</button>
                          <button class="btn btn-light btn-sm rounded text-danger border text-xxs" @click.prevent="deleteEvent(event.id)">Delete</button>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
                </div>

                      <div v-else class="text-center py-5">
                        <i class="bi bi-calendar-x display-1 text-muted mb-3"></i>
                        <p class="text-muted fs-5 mb-1">No past events.</p>
                        <p class="text-muted text-xxs mb-3">Past events will appear here.</p>
                      </div>

                    </div>

                </div>
                <div class="tab-pane fade" id="free_events_info" role="tabpanel">
                  <div class="mt-2">
                    <div class="row g-2 mb-3">
                      <div
                        v-for="card in free_event_dashboard_cards"
                        :key="card.label"
                        class="col-6 col-md-4 col-xl"
                      >
                        <button
                          type="button"
                          class="dashboard-summary-card btn border rounded bg-white p-3 h-100 w-100 text-start shadow-sm"
                          :class="{ 'border-primary bg-light': is_free_event_dashboard_card_active(card) }"
                          @click="handle_free_event_dashboard_card_click(card)"
                        >
                          <div class="d-flex align-items-start justify-content-between gap-3 h-100">
                            <div class="d-flex flex-column justify-content-between h-100 min-w-0">
                              <div class="text-muted text-xxs fw-bold text-uppercase text-truncate">{{ card.label }}</div>
                              <div class="fw-bold text-dark h4 mb-0 mt-2">{{ card.value }}</div>
                            </div>
                            <span class="portal-dashboard-card-icon rounded-circle d-inline-flex align-items-center justify-content-center bg-light border flex-shrink-0">
                              <i class="bi" :class="[`text-${card.tone}`, card.icon]"></i>
                            </span>
                          </div>
                        </button>
                      </div>
                    </div>

                    <div v-if="filtered_free_dashboard_events && filtered_free_dashboard_events.length" class="table-responsive">
                      <table class="table align-middle table-striped table-borderless mb-0 data-table">
                        <thead class="text-uppercase btn-primary text-white">
                          <tr>
                            <th class="text-xxs fw-light text-center">No.</th>
                            <th class="text-xxs fw-light">Event</th>
                            <th class="text-xxs fw-light text-center">Status</th>
                            <th class="text-xxs fw-light text-center">Recurrence</th>
                            <th class="text-xxs fw-light text-center">Start Date</th>
                            <th class="text-xxs fw-light text-center">End Date</th>
                            <th class="text-xxs fw-light text-center">RSVP Start</th>
                            <th class="text-xxs fw-light text-center">RSVP End</th>
                            <th class="text-xxs fw-light text-center">Organizer</th>
                            <th class="text-xxs fw-light text-center">Location</th>
                            <th class="text-xxs fw-light text-center">Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(event, index) in filtered_free_dashboard_events" :key="event.id" class="border-bottom text-xxs">
                            <td class="text-center">{{ index + 1 }}
                            </td>
                            <td><div class="text-xxs">{{ event.event_name }}</div></td>
                            <td class="text-center">
                              <span>{{ is_upcoming_event(event) ? 'Upcoming' : 'Past' }}</span>
                            </td>
                            <td class="text-center">
                              <span>{{ event.recurring_pattern?.name || '-' }}</span>
                            </td>
                            <td class="text-center">{{ event.start_date }}</td>
                            <td class="text-center">{{ event.end_date }}</td>
                            <td class="text-center">{{ event.rsvp_start_date }}</td>
                            <td class="text-center">{{ event.rsvp_end_date }}</td>
                            <td class="text-center">{{ event.organizer }}</td>
                            <td class="text-center event-location-cell">{{ event.location }}</td>
                            <td class="text-center">
                              <div class="d-flex justify-content-center gap-1">
                                <button class="btn btn-light btn-sm rounded text-success border text-xxs" @click.prevent="view_event(event)">View</button>
                                <button v-if="is_upcoming_event(event)" class="btn btn-light btn-sm rounded text-success border text-xxs" @click.prevent="edit_event(event)">Edit</button>
                                <button class="btn btn-light btn-sm rounded text-danger border text-xxs" @click.prevent="deleteEvent(event.id)">Delete</button>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <div v-else class="text-center py-5">
                      <i class="bi bi-gift display-1 text-muted mb-3"></i>
                      <p class="text-muted fs-5 mb-1">No free events.</p>
                      <p class="text-muted text-xxs mb-3">Free events will appear here.</p>
                    </div>
                  </div>
                </div>
                <div class="tab-pane fade" id="paid_events_info" role="tabpanel">
                  <div class="mt-2">
                    <div class="row g-2 mb-3">
                      <div
                        v-for="card in paid_event_dashboard_cards"
                        :key="card.label"
                        class="col-6 col-md-4 col-xl"
                      >
                        <button
                          type="button"
                          class="dashboard-summary-card btn border rounded bg-white p-3 h-100 w-100 text-start shadow-sm"
                          :class="{ 'border-primary bg-light': is_paid_event_dashboard_card_active(card) }"
                          @click="handle_paid_event_dashboard_card_click(card)"
                        >
                          <div class="d-flex align-items-start justify-content-between gap-3 h-100">
                            <div class="d-flex flex-column justify-content-between h-100 min-w-0">
                              <div class="text-muted text-xxs fw-bold text-uppercase text-truncate">{{ card.label }}</div>
                              <div class="fw-bold text-dark h4 mb-0 mt-2">{{ card.value }}</div>
                            </div>
                            <span class="portal-dashboard-card-icon rounded-circle d-inline-flex align-items-center justify-content-center bg-light border flex-shrink-0">
                              <i class="bi" :class="[`text-${card.tone}`, card.icon]"></i>
                            </span>
                          </div>
                        </button>
                      </div>
                    </div>

                    <div v-if="filtered_paid_dashboard_events && filtered_paid_dashboard_events.length" class="table-responsive">
                      <table class="table align-middle table-striped table-borderless mb-0 data-table">
                        <thead class="btn-primary text-white">
                          <tr>
                            <th class="text-xxs fw-light text-center">No.</th>
                            <th class="text-xxs fw-light">Event</th>
                            <th class="text-xxs fw-light text-center">Status</th>
                            <th class="text-xxs fw-light text-center">Recurrence</th>
                            <th class="text-xxs fw-light text-center">Start Date</th>
                            <th class="text-xxs fw-light text-center">End Date</th>
                            <th class="text-xxs fw-light text-center">Organizer</th>
                            <th class="text-xxs fw-light text-center">Location</th>
                            <th class="text-xxs fw-light text-center">Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(event, index) in filtered_paid_dashboard_events" :key="event.id" class="border-bottom text-xxs">
                            <td class="text-center">{{ index + 1 }}</td>
                            <td>{{ event.event_name }}</td>
                            <td class="text-center">
                              <span>{{ is_upcoming_event(event) ? 'Upcoming' : 'Past' }}</span>
                            </td>
                            <td class="text-center">
                              <span>{{ event.recurring_pattern?.name || '-' }}</span>
                            </td>
                            <td class="text-center">{{ event.start_date }}</td>
                            <td class="text-center">{{ event.end_date }}</td>
                            <td class="text-center">{{ event.organizer }}</td>
                            <td class="text-center event-location-cell">{{ event.location }}</td>
                            <td class="text-center">
                              <div class="d-flex justify-content-center gap-1">
                                <button class="btn btn-light btn-sm rounded text-success border text-xxs" @click.prevent="view_event(event)">View</button>
                                <button v-if="is_upcoming_event(event)" class="btn btn-light btn-sm rounded text-success border text-xxs" @click.prevent="edit_event(event)">Edit</button>
                                <button class="btn btn-light btn-sm rounded text-danger border text-xxs" @click.prevent="deleteEvent(event.id)">Delete</button>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <div v-else class="text-center py-5">
                      <i class="bi bi-ticket-perforated display-1 text-muted mb-3"></i>
                      <p class="text-muted fs-5 mb-1">No paid events.</p>
                      <p class="text-muted text-xxs mb-3">Paid events will appear here.</p>
                    </div>
                  </div>
                </div>
            </div>
          </div>
        </div>
          </div>

      </div>

    </div> <!-- /row -->
  </div> <!-- /container-fluid -->

</div> <!-- /app shell -->

<teleport to="body">
<div class="modal fade" id="event_modal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
    <div class="modal-dialog modal-lg modal-dialog-scrollable modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header bg-primary text-white position-relative">
          <p class="modal-title text-xxs fw-500" id="exampleModalLabel">{{ event_id ? 'Edit Event' : 'Create your event'}}
          </p>
          <button
            type="button"
            class="btn-close btn-close-white position-absolute end-0 top-50 translate-middle-y me-2"
            data-bs-dismiss="modal"
            aria-label="Close">
          </button>
        </div>
        <form @submit.prevent="event_id ? update_event() : submit_form()">
          <div class="modal-body modal-body-scroll">

            <div class="mb-3">
              <label for="event_name" class="form-label text-xxs fw-500">Event Name <span
                  class="text-danger">*</span></label>
              <input type="text" class="form-control rounded text-xxs" id="event_name" placeholder="Enter event name"
                v-model="event_name">
              <p v-if="errors.event_name" class="text-danger text-xxs">{{ errors.event_name }}</p>
            </div>
            <div class="d-flex flex-row justify-content-between mx-1">
            </div>
            <div class="d-flex flex-row justify-content-between mx-1">
              <div v-if="$route.name !== 'organisation' && !event_id  && portals.length > 0">
                <label for="portals" class="form-label text-xxs fw-500">Tag a portal :
                </label>
                <select class="text-xxs btn-primary fw-500 border-0 rounded btn-sm mb-3 border-end"
                  v-model="selectedPortalId" id="portals">
                  <option value="" selected hidden>
                   Tag a portal
                  </option>
                  <option v-for="portal in portals" :value="portal.id" :key="portal.id">{{ portal.name }}</option>
                </select>
              </div>
            </div>
            <div class="mb-3">
              <label class="form-label text-xxs fw-500">Event Type <span class="text-danger">*</span></label>
              <div class="d-flex flex-row align-items-center">
                <div v-for="(type, index) in event_types" :key="index" class="form-check me-3">
                  <input type="radio" class="form-check-input" :value="type" v-model="event_type" :id="`${type}_event`"
                    :name="`event_type`" />
                  <label :for="`${type}_event`" class="form-check-label">{{ type.name }}</label>
                </div>
              </div>
              <p v-if="errors.event_type" class="text-danger text-xxs">{{ errors.event_type }}</p>
            </div>
            <div v-if="!event_id" class="col-md-6 mb-3">
              <div v-if="user_details.user_role=='admin'">
            <label class="form-label text-xxs fw-500">Event Category</label>
            <div class="d-flex flex-row align-items-center gap-3">
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio" id="free_event"
                  :value="true"
                  v-model="is_free"
                  checked
                />
                <label class="form-check-label text-xxs" for="free_event">Free</label>
              </div>
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  id="paid_event"
                  :value="false" v-model="is_free"

                />
                <label class="form-check-label text-xxs" for="paid_event">Paid</label>
              </div>
            </div>
              </div>
          </div>

          <div v-if="!is_free">
  <label class="form-label text-xxs fw-500">Select Tickets <span class="text-danger">*</span></label>
<div v-for="ticket in allTickets" :key="ticket.id" class="form-check mb-2">
  <input
    type="checkbox"
    :id="'ticket_' + ticket.id"
    :value="ticket.id"
    v-model="selectedTickets"
    class="form-check-input"
    :disabled="assignedTicketIds.includes(ticket.id)"

  />
  <label :for="'ticket_' + ticket.id" class="form-check-label">
    {{ ticket.name }}
    <span v-if="assignedTicketIds.includes(ticket.id)" class="text-muted"></span>
  </label>
</div>

  <!-- Dynamic ticket fields -->
<div
  v-for="ticket in selectedTicketsData"
  :key="'fields_' + ticket.id"
  class="p-3 mb-3 border rounded bg-light"
>
  <h6>{{ ticket.name }}</h6>

  <!-- Price -->
  <div class="mb-3">
    <label class="form-label text-xxs fw-500">Price (R)</label>
    <input
      type="number"
      class="form-control rounded text-xxs"
      v-model.number="ticket.price"
      step="0.01"
      min="0"
      :readonly="ticket.readOnly"
    />
  </div>

  <!-- Quantity -->
  <div class="mb-3">
    <label class="form-label text-xxs fw-500">Quantity</label>
    <input
      type="number"
      class="form-control rounded text-xxs"
      v-model.number="ticket.quantity"
      min="0"
      :readonly="ticket.readOnly"
    />
  </div>

  <!-- Start Date -->
  <div class="mb-3">
    <label class="form-label text-xxs fw-500">Ticket Start Date</label>
    <input
      type="datetime-local"
      class="form-control rounded text-xxs"
      v-model="ticket.start_date"
      :readonly="ticket.readOnly"
    />
    <p v-if="errors[`ticket_${ticket.id}_start_date`]" class="text-danger text-xxs">
  {{ errors[`ticket_${ticket.id}_start_date`] }}
</p>
  </div>

  <!-- End Date -->
  <div class="mb-3">
    <label class="form-label text-xxs fw-500">Ticket End Date</label>
    <input
      type="datetime-local"
      class="form-control rounded text-xxs"
      v-model="ticket.end_date"
      :readonly="ticket.readOnly"
    />
      <p v-if="errors[`ticket_${ticket.id}_end_date`]" class="text-danger text-xxs">
    {{ errors[`ticket_${ticket.id}_end_date`] }}
  </p>
  </div>
</div>
</div>


          <div class="d-flex flex-column ">
            <div v-for="ticket in availableTickets" :key="ticket.id" class="form-check">
              <input
                class="form-check-input"
                type="checkbox"
                :id="'ticket_' + ticket.id"
                :value="ticket.id"
                v-model="selectedTickets"
              />
              <label class="form-check-label text-xxs" :for="'ticket_' + ticket.id">
                {{ ticket.name }} - R{{ ticket.price }} ({{ ticket.quantity }} available)
              </label>
            </div>
          </div>




<div class="col-md-6 mb-3">
  <label class="form-label text-xxs fw-500">Is Recurring?</label>
  <div class="d-flex flex-row align-items-center gap-3">
    <div class="form-check">
      <input class="form-check-input" type="radio" id="recurring_yes" :value="true" v-model="is_recurring" />
      <label class="form-check-label text-xxs" for="recurring_yes">Yes</label>
    </div>
    <div class="form-check">
      <input class="form-check-input" type="radio" id="recurring_no" :value="false" v-model="is_recurring" />
      <label class="form-check-label text-xxs" for="recurring_no">No</label>
    </div>
  </div>
</div>



<div class="col-md-6 mb-3" v-if="is_recurring">
  <label for="recurring_type" class="form-label text-xxs fw-500">Recurrence Pattern <span
      class="text-danger">*</span></label>
  <select class="form-select rounded text-xxs" id="recurring_type" v-model="recurring_type">
    <option value="" disabled selected>Select recurrence</option>
    <option v-for="pattern in recurring_patterns" :key="pattern.id" :value="pattern.id">
      {{ pattern.name }}
    </option>
  </select>
  <p v-if="errors.recurring_type" class="text-danger text-xxs">{{ errors.recurring_type }}</p>
</div>

            <div class="d-flex mt-2 mx-1 justify-content-between align-items-start">
            <div class="file-upload my-2 me-4 flex-grow-1 d-flex flex-column align-items-center">
              <label for="editdocumentFileInput" class="text-xxs text-secondary fw-500 border-0 rounded btn-sm mb-3 bg-light d-flex align-items-center justify-content-center">
                <i class='bx bx-image-add file-upload-icon'></i> Add event content/agenda
              </label>
              <input type="file" id="editdocumentFileInput" class="file-input d-none" @change="handleFileUpload"/>
              <div v-if="fileName" class="text-xxs text-secondary fst-italic mt-1">
                <span class="fw-500">File name:</span> {{fileName }}
              </div>
              <div v-if="fileError" class="text-xxs text-danger fst-italic mt-1">{{ fileError }}</div>
            </div>
          </div>
            <QuillEditor theme="snow" v-model="event_description" ref="quillEventEditorRef" class="quill-editor"
              placeholder="Enter your description here..." toolbar="full" />
            <div class="row">
              <!-- Event Start Date -->
              <div class="col-md-3 mb-3">
                <label for="start_date" class="form-label text-xxs fw-500">Event Start Date <span
                    class="text-danger">*</span></label>
                <input type="date" class="form-control rounded text-xxs" id="start_date" v-model="start_date" :min="todayDate">
                <p v-if="errors.start_date" class="text-danger text-xxs">{{ errors.start_date }}</p>
              </div>
              <div class="col-md-3 mb-3">
                 <label for="end_time" class="form-label text-xxs fw-500">Start Time <span
                    class="text-danger">*</span></label>
                <input type="time" class="form-control rounded text-xxs" id="start_time" v-model="start_time">

              <p v-if="errors.start_time" class="text-danger text-xxs mt-1">{{ errors.start_time }}</p>
            </div>


              <!-- Event End Date -->
              <div class="col-md-3 mb-3">
                <label for="end_date" class="form-label text-xxs fw-500">Event End Date <span
                    class="text-danger">*</span></label>
                <input type="date" class="form-control rounded text-xxs" id="end_date" v-model="end_date" :min="todayDate">
                <p v-if="errors.end_date" class="text-danger text-xxs">{{ errors.end_date }}</p>
              </div>
              <div class="col-md-3 mb-3">
                <label for="end_time" class="form-label text-xxs fw-500">End Time <span
                    class="text-danger">*</span></label>
                <input type="time" class="form-control rounded text-xxs" id="end_time" v-model="end_time">
                <p v-if="errors.end_time" class="text-danger text-xxs">{{ errors.end_time }}</p>
              </div>

              <!-- RSVP Start Date -->
              <div v-if="is_free"class="col-md-3 mb-3">
                <label for="rsvp_start_date" class="form-label text-xxs fw-500">RSVP Start Date <span
                    class="text-danger">*</span></label>
                <input type="date" class="form-control rounded text-xxs" id="rsvp_start_date"
                  v-model="rsvp_start_date" :min="todayDate">
                <p v-if="errors.rsvp_start_date" class="text-danger text-xxs">{{ errors.rsvp_start_date }}</p>
              </div>
              <div v-if="is_free"class="col-md-3 mb-3">
                <label for="rsvp_start_time" class="form-label text-xxs fw-500">RSVP Start Time <span
                    class="text-danger">*</span></label>
                <input type="time" class="form-control rounded text-xxs" id="rsvp_start_time"
                  v-model="rsvp_start_time">
                <p v-if="errors.rsvp_start_time" class="text-danger text-xxs">{{ errors.rsvp_start_time }}</p>
              </div>

              <!-- RSVP End Date -->
              <div v-if="is_free"class="col-md-3 mb-3">
                <label for="rsvp_end_date" class="form-label text-xxs fw-500">RSVP End Date <span
                    class="text-danger">*</span></label>
                <input type="date" class="form-control rounded text-xxs" id="rsvp_end_date" v-model="rsvp_end_date" :min="todayDate">
                <p v-if="errors.rsvp_end_date" class="text-danger text-xxs">{{ errors.rsvp_end_date }}</p>
              </div>
              <div v-if="is_free"class="col-md-3 mb-3">
                <label for="rsvp_end_time" class="form-label text-xxs fw-500">RSVP End Time <span
                    class="text-danger">*</span></label>
                <input type="time" class="form-control rounded text-xxs" id="rsvp_end_time" v-model="rsvp_end_time">
                <p v-if="errors.rsvp_end_time" class="text-danger text-xxs">{{ errors.rsvp_end_time }}</p>
              </div>
            </div>

            <div class="mb-3">
              <label for="organizer" class="form-label text-xxs fw-500">Organizer <span
                  class="text-danger">*</span></label>
              <input type="text" class="form-control rounded text-xxs" id="organizer"
                placeholder="Enter organizer name" v-model="organizer">
              <p v-if="errors.organizer" class="text-danger text-xxs">{{ errors.organizer }}</p>
            </div>
            <div v-if="event_type.name === 'online' || event_type.name === 'hybrid'" class="mb-4">
              <label for="event_link" class="form-label text-xxs fw-500 d-block">Event Link <span
                  class="text-danger">*</span></label>
              <input id="event_link" type="url" class="form-control rounded text-xxs"
                placeholder="Enter event link (e.g., Zoom, Google Meet,Teams)" v-model="event_link" />
              <p v-if="errors.event_link" class="text-danger text-xxs">{{ errors.event_link }}</p>
            </div>
            <div v-if="event_type.name !== 'online'" :key="event_type.name" class="mb-4">
              <label for="mapSearchBox" class="form-label text-xxs fw-500 d-block">Search for Location</label>
              <input id="mapSearchBox" type="text" class="form-control rounded text-xxs"
                placeholder="Search location..." v-model="location" />
              <p v-if="errors.location" class="text-danger text-xxs">{{ errors.location }}</p>
            </div>

            <div class="event-extras"v-if="show_add_extras && is_free">
              <div class="d-flex justify-content-between align-items-center mb-3">
                <h3 class="text-xxs fw-500 mb-0">Event Extra</h3>
                <button type="button" class="btn btn-outline-primary btn-sm rounded text-xxs"
                  @click.prevent="addExtra">
                  <i class="bx bx-plus"></i>
                  Add Extra Item
                </button>
              </div>

              <div id="extraItemsList" class="mt-3">
              </div>
            </div>
            <div class="container mt-4"  v-if="showExtrasForm && show_add_extras && extraForms.length > 0">
            <div v-for="(extraForm, extraIndex) in extraForms" :key="extraIndex" id="select_extra_container"
              class="border rounded-3 p-3 mt-3 bg-light">

              <input v-model="extraForm.id" type="text"  class="d-none extra_form_id">

              <div class="mb-3">
                <label class="form-label text-xxs fw-500">Select Extra:</label>
                <input type="text" class="form-control selectExtra" v-model="extraForm.selectedExtra"
                  placeholder="Enter or select extra" :list="'extrasList-' + extraIndex">
                <datalist :id="'extrasList-' + extraIndex">
                  <option v-for="extra in availableExtras" :key="extra.id" :value="extra.name"></option>
                </datalist>
              </div>

              <div v-for="(item, itemIndex) in extraForm.items" :key="itemIndex + '_extra'"
                class="border rounded-3 p-2 mb-2 bg-white">

                <input v-model="item.id" type="text" class="d-none item_id">

                <div class="mb-2">
                  <label class="form-label text-xxs fw-500">Item Name:</label>
                  <input v-model="item.item_name" type="text" class="form-control rounded text-xxs item_name"
                    placeholder="Enter item name">
                </div>


                <div class="mb-2">
                  <label class="form-label text-xxs fw-500">Description:</label>
                  <textarea v-model="item.item_description" type="text" class="form-control rounded-3 text-xxs item_description" rows="2"
                    placeholder="Enter description"></textarea>
                </div>


                <div class="mb-2">
                  <label class="form-label text-xxs fw-500">Price:</label>
                  <input v-model="item.item_price" type="number" class="form-control rounded text-xxs item_price"
                    placeholder="0.00" step="0.01" min="0">
                </div>


                <button @click.prevent="removeExtraItem(extraIndex, itemIndex)" class="btn btn-danger btn-sm">
                  <i class="bx bx-trash"></i>
                </button>
              </div>


              <button @click.prevent="addExtraItem(extraIndex)"
                      class="btn btn-primary btn-sm text-xxs me-2">
                + Add Extra Item
              </button>

            <button @click.prevent="removeExtra(extraIndex)"
                    class="btn btn-danger btn-sm text-xxs">
              Remove Extra
            </button>

            </div>
          </div>
          </div>

          <div class="modal-footer">
            <button type="submit" class="btn btn-primary text-xxs rounded">{{ event_id ? 'Update' : 'Save' }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</teleport>
